module.exports = __webpack_public_path__ + "staticVue/img/advertise-white.81f5f902.png";